<template>
  <div>
    <template v-if="surfaceShow">
      <ListComponent
        type="inventoryManagement"
        :merchant-products="merchantProducts"
        :service-category="serviceCategory"
        :table-checkbox-show="true"
        @openPurchaseInformation="openPurchaseInformation"
        @closeTabAndOpenInventoryDetail="closeTabAndOpenInventoryDetail"
      >
      </ListComponent>
    </template>
    <template v-if="!surfaceShow">
      <PurchasePage :purchase-type="purchaseType" @showInventoryManagement="showInventoryManagement" />
    </template>
  </div>
</template>

<script>
import lazyLoadComponent from '@router/lazyload-component'
export default {
  page: {
    title: '服務項目',
    meta: [{ name: 'description', content: 'Prepaid List' }],
  },
  components: {
    ListComponent: () => lazyLoadComponent(import('./components/ListComponent')),
    PurchasePage: () => lazyLoadComponent(import('./PurchasePage')),
  },
  filters: {},

  props: {
    merchantProducts: {
      type: Array,
      required: true,
    },
    serviceCategory: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      surfaceShow: true,
      purchaseType: 'purchase', // 進貨還是退貨模式=>預設進貨模式
    }
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    /**
     * @description 關閉tab，並起開啟庫存細節
     */
    closeTabAndOpenInventoryDetail(row){
      this.$emit('closeTabAndOpenInventoryDetail', row)
    },
    /**
     * @description 顯示庫存管理頁面
     */
    showInventoryManagement() {
      this.surfaceShow = true
    },
    /**
     * @description 進出貨畫面控制
     */
    openPurchaseInformation(type) {
      this.surfaceShow = false
      this.purchaseType = type
    },
  },
}
</script>

<style lang="scss" module></style>
